import React from 'react';
import styled from 'styled-components';

const BookerSkeleton = () => {
    return (
        <div
            className='calcom-atoms m-0 w-auto bg-transparent p-0 atoms-wrapper booker-skeleton'
            dir='ltr'
        >
            <div className='main text-default flex min-h-full w-full flex-col items-center my-20 overflow-visible undefined'>
                <BookerContainer className='[--booker-timeslots-width:240px] lg:[--booker-timeslots-width:280px] [--booker-meta-width:240px] [--booker-main-width:480px] lg:[--booker-meta-width:280px] bg-default dark:bg-muted grid max-w-full items-start dark:[color-scheme:dark] sm:motion-reduce:transition-none md:flex-row rounded-md sm:transition-[width] sm:duration-300 border-subtle border booker-container'>
                    <MetaSectionContainer className='relative z-10 flex [grid-area:meta]'>
                        <div className='[grid-area:meta] max-w-screen flex w-full flex-col md:w-[var(--booker-meta-width)] w-full'>
                            <div className='event-meta-container relative z-10 p-6'>
                                <PulsatingRow />
                                <PulsatingRow />
                                <PulsatingRow />
                            </div>
                        </div>
                    </MetaSectionContainer>
                    <MainSectionContainer className='[grid-area:main] md:border-subtle ml-[-1px] h-full flex-shrink px-5 py-3 md:border-l lg:w-[var(--booker-main-width)]'>
                        <div className='date-picker-container'>
                            <div className='mb-1 flex items-center justify-between text-xl'>
                                <span className='text-default w-1/2 text-base' />
                                <PulsatingRow />
                            </div>
                            <div className='border-subtle mb-2 grid grid-cols-7 gap-4 border-b border-t text-center md:mb-0 md:border-0'>
                                {[
                                    'Sun',
                                    'Mon',
                                    'Tue',
                                    'Wed',
                                    'Thu',
                                    'Fri',
                                    'Sat',
                                ].map((day) => (
                                    <Day key={day} day={day} />
                                ))}
                            </div>
                            <div className='relative grid grid-cols-7 grid-rows-6 gap-1 text-center'>
                                {[...Array(35)].map((_, i) => (
                                    <DateCell key={i} />
                                ))}
                            </div>
                        </div>
                    </MainSectionContainer>
                    <TimeslotsContainer className='[grid-area:timeslots] border-subtle rtl:border-default flex w-full flex-col px-5 py-3 pb-0 rtl:border-r ltr:md:border-l h-full overflow-hidden md:w-[var(--booker-timeslots-width)]'>
                        <div className='flex available-time-slots-container'>
                            <div className='mb-3 h-8'></div>
                        </div>
                        <div className='scroll-bar flex-grow overflow-auto md:h-[400px] available-time-slots-container'>
                            <div className='flex w-[20%] flex-col only:w-full'>
                                <PulsatingRow />
                                <PulsatingRow />
                            </div>
                        </div>
                    </TimeslotsContainer>
                </BookerContainer>
            </div>
        </div>
    );
};

export default BookerSkeleton;

const BookerContainer = styled.div`
    grid-template-areas: 'meta main timeslots' 'meta main timeslots';
    width: calc(
        var(--booker-meta-width) + var(--booker-main-width) +
            var(--booker-timeslots-width)
    );
    grid-template-columns: var(--booker-meta-width) 1fr var(
            --booker-timeslots-width
        );
    grid-template-rows: 1fr 0fr;
    min-height: 450px;
    height: auto;
`;

const SectionContainer = styled.div`
    opacity: 1;
    transform: none;
`;

const MetaSectionContainer = styled(SectionContainer)`
    min-width: 100%;

    > div {
        min-width: 100%;
    }
`;

const MainSectionContainer = styled(SectionContainer)``;

const TimeslotsContainer = styled(SectionContainer)``;

const Day = ({ day }: { day: string }) => (
    <div className='text-emphasis my-4 text-xs font-medium uppercase tracking-widest date-picker-days'>
        {day}
    </div>
);

const DateCell = () => (
    <div className='relative w-full pt-[100%]'>
        <button
            className='bg-muted text-muted absolute bottom-0 left-0 right-0 top-0 mx-auto flex w-full items-center justify-center rounded-sm border-transparent text-center font-medium opacity-90 transition'
            disabled
        >
            <span className="font-size-0 bg-emphasis inline-block animate-pulse rounded-md empty:before:inline-block empty:before:content-[''] h-8 w-9" />
        </button>
    </div>
);

const PulsatingRow = () => (
    <div className="font-size-0 bg-emphasis inline-block animate-pulse rounded-md empty:before:inline-block empty:before:content-[''] mb-4 h-6 w-full" />
);
